import Vue from 'vue';
import { Component } from 'vue-property-decorator';

@Component({
  name: 'CmgHowItWorks',
})
export default class CmgHowItWorks extends Vue {
  get isLoggedIn() {
    return this.$services.customer.isLoggedIn() === true;
  }
}
